import './index.css';
import { View, Text, FlatListAutoHeight } from '../../../component';
import FlatList from 'flatlist-react';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';
interface Props {
  list: any;
}
const GrandLeagueWinnings = ({ list }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const renderItem = (item: any) => {
    const { prize = '', rank = '', isBonus = false, imageLink = '' } = item;
    const prize_ = `${prize}` + (isBonus ? `  (Bonus)` : '');
    const titleStyle = {
      color: theme.GLLeaderBoardItemTitle,
      backgroundColor: theme.GLLeaderBoardItemBoxBG
    };
    return (
      <View className="grand-league-winnings-container">
        <Text style={titleStyle} className="grand-league-winnings-title">{`${rank}`}</Text>
        <View style={titleStyle} className="grand-league-winnings-value-wrapper">
          {imageLink && (
            <img
              src={imageLink}
              style={{
                height: 35,
                padding: 2
              }}
            />
          )}
          <Text style={titleStyle} className="grand-league-winnings-value">{`${prize_}`}</Text>
        </View>
      </View>
    );
  };

  const headerTitleStyle = {
    color: theme.GLLeaderBoardHeaderTitle,
    backgroundColor: theme.GLLeaderBoardHeaderBoxBG
  };

  return (
    <View className="grand-league-winnings-wrapper">
      <View className="grand-league-winnings-container">
        <Text
          style={{
            fontSize: '1.2rem',
            lineHeight: '35px',
            ...headerTitleStyle
          }}
          className="grand-league-winnings-header-title">{`Rank`}</Text>
        <Text
          style={{
            fontSize: '1.2rem',
            lineHeight: '35px',
            ...headerTitleStyle
          }}
          className="grand-league-winnings-header-value">{`Prize`}</Text>
      </View>
      <FlatListAutoHeight>
        <FlatList list={list} renderItem={renderItem} />
      </FlatListAutoHeight>
    </View>
  );
};
export default React.memo(GrandLeagueWinnings);
